import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "@babel/polyfill";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";

import globals from "./config/globals";
Vue.use(globals, store);

import Loader from "./components/loader/Loader";
import LoaderOverlay from "./components/loaderOverlay/LoaderOverlay";

Vue.component("loader", Loader);
Vue.component("loader-overlay", LoaderOverlay);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
